export default "__VITE_ASSET__U1HA47qs__"